var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1732 49.004C51.7628 48.8812 52.113 48.2673 51.8707 47.7159C50.5356 44.6785 48.0748 42.0058 44.7839 40.0417C41.1164 37.8529 36.6227 36.6665 31.9999 36.6665C27.3771 36.6665 22.8834 37.8529 19.2159 40.0417C15.925 42.0058 13.4642 44.6785 12.1291 47.7159C11.8868 48.2673 12.237 48.8811 12.8266 49.004L23.839 51.2991C29.2218 52.4209 34.778 52.4209 40.1608 51.2991L51.1732 49.004Z",
    fill: "#A8A8A8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22.6667,
    r: 11.6667,
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/ProfileImg.ff59cc7261e4ff3cb089c865d908cccd.svg";
export { ForwardRef as ReactComponent };